import { mainApi } from "../services/main/api";
import { IAssociationDetails } from "./getArtifactDetailsById";

const extendedApi = mainApi.injectEndpoints({
    endpoints: builder => ({
        getRealPropertyDetails: builder.query<IRealPropertyResponse, GetRealPropertyByIdRequest>({
            query: (request: GetRealPropertyByIdRequest) => ({
                url: "getRealProperty",
                body: request,
                method: "POST",
            }),
            keepUnusedDataFor: 1,
        }),
    }),
    overrideExisting: false,
});

export const { useGetRealPropertyDetailsQuery } = extendedApi;

export interface GetRealPropertyByIdRequest {
    artifactId: string;
    businessUseCase: string;
}

export interface IRealPropertyResponse {
    featureDetails: IFeatureDetails[];
    propertyDetails: IPropertyDetails;
    siteImprovementDetails: ISiteImprovementDetails[];
    spaceDetails: ISpaceDetails[];
    isValidated: boolean;
    missingFields: string[];
}

export interface IPropertyDetails {
    // Common Fields
    grossLeasableAreaUnit?: string;
    siteArea?: string;
    ownershipStatus?: string;
    association?: IAssociationDetails;
    saleDate?: string;
    dateClosed?: string;
    yearBuilt?: string;
    climate?: string;
    effectiveYear?: string;
    age?: string;
    dateOpened?: string;
    dateRevised?: string;
    filingDueDate?: string;
    appealDeadline?: string;
    dateOfHearing?: string;
    secDivision?: string;
    currency?: string;
    grossBuildingAreaUnit?: string;
    siteCode?: string;
    address?: IAddressDetails;
    comments?: string;
    grossBuildingArea?: string;
    salePrice?: string;
    siteUsableArea?: string;
    assignedUser?: string;
    siteUsableAreaUnit?: string;
    grossLeasableArea?: string;
    siteAreaUnit?: string;
    otherDescription?: string;
    constructionCosts?: string;
    contacts?: string;
    propertyNumber?: string;
    status?: string;
    leaseRate?: string;
    propertyId?: string;
    appealNumber?: string;
    appraisedValueAmount?: string;
    appraisedValueCurrency?: string;
    assessedValueAmount?: string;
    assessedValueCurrency?: string;
    buildingValueAmount?: string;
    buildingValueCurrency?: string;
    checkNumber?: string;
    landValueAmount?: string;
    landValueCurrency?: string;
    marketValueAmount?: string;
    marketValueCurrency?: string;
    propertyDescription?: string;
    reasonForCheck?: string;
    taxableValueAmount?: string;
    taxableValueCurrency?: string;
    taxAmountAmount?: string;
    taxAmountCurrency?: string;
    taxBillEstimateAmount?: string;
    taxBillEstimateCurrency?: string;
    taxYear?: string;
    tenantName?: string;
    totalTaxesOwedAmount?: string;
    totalTaxesOwedCurrency?: string;
    totalValueAmount?: string;
    totalValueCurrency?: string;
    trueAmountDueAmount?: string;
    trueAmountDueCurrency?: string;
    artifactId?: string;
    artifactType?: string;
    treasureStatus?: string;
    failureReason?: string;

    // Property Specific Fields
    propertyType?: string;
    propertySubType?: string;
    generalLedgerNumber?: string;
    subType?: string;
    entityCode?: string;
    entityName?: string;

    // Parcel Specific Fields
    entity?: string;
    parcelType?: string;
    parcelSubType?: string;
    parcelNumber?: string;

    // Document Specific Fields
    documentType?: string;
    associatedPropertyType?: string;
    dueDate?: string;
    bblCode?: string;
    invoiceNumber?: string;
    assessedValue?: number;
    totalValue?: string;
    numberOfPayments?: string | number;
    earliestPaymentDueDate?: string;
    receiveDate?: string;
    marketValue?: string;
    landValue?: string;
    totalTaxesOwed?: number;
    accountNumber?: string;
    canopyId?: string;
    taxableValue?: number;
    trueAmountDue?: number;
    mailId?: string;
    documentS3Key?: string;
    createdByUser?: string;
    companyName?: string;
    assignedTo?: string;
    buildingValue?: string;
    discounts?: string;
    appraisedValue?: string;
    taxDistrict?: string;
    buildingCode?: string;
    documentS3PreSignedUrl?: string;

    // Comment Specific Fields
    text?: string;
    commentedBy?: string;
}

export interface IAddressDetails {
    county: string;
    country: string;
    zipCode: string;
    streetAddress: string;
    state: string;
    city: string;
    jurisdiction: string;
}

export interface IFeatureDetails {
    artifactId: string;
    featureName: string;
    featureType: string;
    quantity: number;
}

export interface IImage {
    type: string;
    fileName: string;
    s3Key: string;
}

export interface ISiteImprovementDetails {
    artifactId: string;
    isApplicable: string;
    quantity: number;
    siteImprovementName: string;
    siteImprovementType: string;
}

export interface ISpaceDetails {
    artifactId: string;
    avgFloorArea: number;
    avgStoryHeight: number;
    avgPerimeter: number;
    condition: string;
    constructionClass: string;
    constructionQuality: string;
    heightPerStory: number;
    landSize: number;
    noOfStories: number;
    occupancyTypeDescription: string;
    officePercentage: number;
    primary: boolean;
    propertyType: string;
    rentalClass: string;
    spaceName: string;
    spaceType: string;
    status: string;
    use: string;
}
